module.exports = __webpack_public_path__ + "img/aw.c9670683.svg";